import { type TExperiments } from '@/app/shared/types/experiments';

import { useReduxSelector } from '../../../hooks';
import { rootStateBranchSelector } from '../../../utils/rootStateBranchSelector';

export const experimentsSelector = rootStateBranchSelector('experiments');

export function useExperimentsSelector(): TExperiments {
  return useReduxSelector(experimentsSelector);
}
